// OPTIMIZATION: Lazy load Firebase - only load when needed for authentication
// This removes ~300KB from the initial bundle

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "YOUR_API_KEY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "YOUR_PROJECT_ID.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "YOUR_PROJECT_ID",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "YOUR_PROJECT_ID.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "YOUR_MESSAGING_SENDER_ID",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "YOUR_APP_ID"
};

// Cache the initialized Firebase instance
let firebaseApp = null;
let firebaseAuth = null;

// Lazy initialization function - only loads Firebase when called
export const getFirebaseAuth = async () => {
  if (firebaseAuth) {
    return firebaseAuth;
  }

  console.log('⚡ Lazy loading Firebase SDK...');
  
  // Dynamic import - only loads when this function is called
  const { initializeApp } = await import('firebase/app');
  const { getAuth } = await import('firebase/auth');
  
  firebaseApp = initializeApp(firebaseConfig);
  firebaseAuth = getAuth(firebaseApp);
  
  console.log('✅ Firebase SDK loaded');
  
  return firebaseAuth;
};

